import { SET_CURRENT_CHATROOM } from '../actions';

export const currentChatroom = (state = null, action) => {
  switch (action.type) {
    case SET_CURRENT_CHATROOM: {
      return action.chatroom;
    }
    default:
      return state;
  }
};
